import React, { useEffect, useState } from 'react'
import Header from '../../Common/Header/Header'
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { deleteLessonByID, searchLesson, getAllLesson, getLessonByID, addNewLesson, deleteUnitByID, updateLesson, checkLessonNameExist, checkUnitNameExist } from '../../../api/lesson';
import FailurePoup from '../../Common/MessagePopup/FailurePopup';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import DatePicker from 'react-datepicker';
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { Form } from 'react-bootstrap';
import { getAllTribes, getTribeById } from '../../../api/tribe';
import { LessonDataType, TableLessonDataType, UnitDataType } from './LessonInterface';
import { getGrade } from '../../../api/tribe';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import { IdAndName, LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { Tooltip } from "react-tooltip";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import FullScreenImagePreview from '../../Common/LottieAnimation/FullScreenImagePreview';

const Lesson = () => {
  const dispatch = useAppDispatch()
  const [confirmationPopupData, setConfirmationPopupData] = useState({
    title: "",
    message: "",
    descriptions: "",
    acceptText: "",
    cancelText: "",
    onAccept: () => { },
    onCancel: () => { },
  });


  const [openLessonPage, setOpenLessonPage] = useState<boolean>(false);


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);


  const { access_token, refresh_token } = useAppSelector((state) => state.user.token)
  const [activeFilter, setActiveFilter] = useState<{ status: string, grade: IdAndName }>({
    status: "",
    grade: { id: "", name: "" },
  })
  const [searchtext, setSearchText] = useState<string>('');
  const [tableLessonData, setLableLessonData] = useState<TableLessonDataType[]>([]);
  const [filter, setFilter] = useState<{ status: string, dateFilter: string, grade: string }>({ status: "", dateFilter: "", grade: "" })
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [lessonCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState<LoadingDataType>({
    fetchingLoading: false,
    tableLoading: false,
    deleteLoading: false,
    submitLoading: false,
    validationLoading: false,

  });
  const [message, setMessage] = useState<MessageDataType>({
    errorMessage: [],
    successMessage: "",
    failureMessage: ""
  })
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const [lessonData, setLessonData] = useState<LessonDataType>({
    id: "",
    lessonName: "",
    lessonTribe: { id: "", name: "" },
    lessonSubject: { id: "", name: "" },
    lessonGrade: { id: "", name: "" },
    deleteS3path: [],
    lessonDescription: "",
    lessonIntroText: "",
    badgeDescription: "",
    lessonMedia: {
      DesktopBanner: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      MobileBanner: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      IntroVideo: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      IntroAudio: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      BadgeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      Thumbnail: {
        files: "",
        blobPath: "",
        fileExtension: ""
      }
    },
    lessonNewUnits: [],
    lessonUnits: [
      {
        id: "",
        name: "",
        level: "",
        unitMedia: {
          desktop: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          badge: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        },
        unitReward: 0,
        isActive: "",
      }],
    lessonReward: 0,
    lessonStatus: ""
  })
  const [dropDownList, setDropDownList] = useState<{ tribe: IdAndName[], subject: IdAndName[], grade: IdAndName[] }>({
    tribe: [],
    subject: [],
    grade: []
  })

  useEffect(() => {
    if (message.errorMessage.length > 0) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

  }, [message.errorMessage.length])

  const allDropDownData = async () => {
    try {
      await getAllTribes(access_token).then((allTribes: any) => {
        const tribeList = allTribes.data.map((tribe: any) => ({
          id: tribe.id,
          name: tribe.name
        }));

        // Update the state with the new tribe data
        setDropDownList((prevState: any) => ({
          ...prevState,
          tribe: tribeList
        }));
      });

    } catch (error: any) {
      console.error("Error fetching tribe data: ", error);

    } finally {
      setTimeout(() => {
        setMessage((prev => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };

  const checkFileLimit = (file: File): boolean => {

    switch (file.type) {
      case "video/mp4":
      case "video/webm":
        return file.size <= 250 * 1024 * 1024; // 250 MB

      case "audio/wav":
      case "audio/mpeg": // standard MIME for mp3
        return file.size <= 20 * 1024 * 1024; // 20 MB

      case "image/png":
      case "image/jpeg": // covers both jpg & jpeg
      case "application/json":
      case "image/svg+xml":
        return file.size <= 20 * 1024 * 1024; // 20 MB

      default:
        // fallback (100 MB limit)
        return file.size <= 100 * 1024 * 1024;
    }
  };



  const handleEndDateChange = (date: any) => {
    const currentDate = new Date(); // Get the current date

    if (!startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "Please select a start date before choosing the end date.",
        ],
      });
      return;
    }

    if (date < startDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be earlier than the start date. Please choose a valid end date.",
        ],
      });
      return;
    }

    if (date > currentDate) {
      setMessage({
        ...message,
        errorMessage: [
          "The end date cannot be in the future. Please select a date that is today or earlier.",
        ],
      });
      return;
    }

    setEndDate(date);
  };

  const [previewSource, setPreviewSource] = useState<string>("");
  const [showPreview, setShowPreview] = useState<{ imageShow: boolean, animationShow: boolean }>({ imageShow: false, animationShow: false })


  const handleOpenImage = (file: any) => {

    if (file instanceof File) {
      const objectURL = URL.createObjectURL(file);
      setPreviewSource(objectURL);

    } else {

      setPreviewSource(file);
    }
    setShowPreview(prev => ({
      ...prev,
      imageShow: true,
      animationShow: false
    }))
  };

  const handleClosePreview = () => {
    setPreviewSource("")
    setShowPreview(prev => ({
      ...prev,
      animationShow: false,
      imageShow: false
    }))
  };



  const getAuthorizedToken = async () => {
    try {
      await getNewAccessToken({ refreshToken: refresh_token }).then((newTokenResponse) => {
        const { data, statusCode } = newTokenResponse;
        if (statusCode === 200) {
          dispatch(setToken({
            access_token: data.data.accessToken,
            refresh_token: data.data.refreshToken
          }))
        }
      })
    } catch (error: any) {
      console.error("Something went wrong in getting new access Token :: ", error)
    }
  }


  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setLessonData({
      ...lessonData,
      [name]: value
    })
  }

  function removeSpans(html: string): string {
    // Remove opening span tags with attributes
    let cleaned = html.replace(/<span[^>]*>/g, "");
    // Remove closing span tags
    cleaned = cleaned.replace(/<\/span>/g, "");
    return cleaned;
  }

  const handleLessonDesriptionChange = (value: string) => {
    setLessonData((prev) => {
      const updatedLessonData = { ...prev }

      updatedLessonData.lessonIntroText = removeSpans(value)

      return updatedLessonData;
    })
  }

  const handleBadgeDescriptionChange = (value: string) => {
    setLessonData((prev) => {
      const updatedLessonData = { ...prev }

      updatedLessonData.badgeDescription = removeSpans(value)

      return updatedLessonData;
    })
    //   ...lessonData,
    //   lessonDescription: value
    // }) 
  }

  const checkLessonName = async () => {
    if (lessonData.lessonTribe.id && lessonData.lessonGrade.id && lessonData.lessonName && lessonData.lessonName.trim() !== "") {
      await checkLessonNameExist(lessonData.id, lessonData.lessonGrade.id, lessonData.lessonName, lessonData.lessonTribe.id).then((checkLessonNameResponse) => {
        const { message, statusCode } = checkLessonNameResponse;
        if (statusCode === 409) {
          setMessage({
            ...message,
            errorMessage: [message]
          })
          return false;
        }
      })
    }


  }



  const handleS3PathDelete = (objectName: string, index: number, s3path: string, file: any) => {
    setShow(true);

    const displayNames: Record<string, string> = {
      DesktopBanner: "Desktop Banner",
      MobileBanner: "Mobile Banner",
      IntroAudio: "Intro Audio",
      IntroVideo: "Lesson Video",
      BadgeIcon: "Badge Icon",
      desktop: "Unit Banner",
      badge: "Unit Badge",
    };


    const updateLessonMedia = (addS3Path: boolean) => {
      setLessonData(prevData => ({
        ...prevData,
        ...(addS3Path && {
          deleteS3path: [...prevData.deleteS3path, s3path]
        }),
        lessonMedia: {
          ...prevData.lessonMedia,
          [objectName]: {
            files: "",
            blobPath: ""
          }
        }
      }));
    };

    const updateWithOptionalDelete = (mediaType: string, isUnit: boolean, addS3Path: boolean) => {
      if (isUnit) {
        setLessonData(prevData => {
          const updatedUnits = [...prevData.lessonUnits];
          updatedUnits[index] = {
            ...updatedUnits[index],
            unitMedia: {
              ...updatedUnits[index].unitMedia,
              [mediaType]: {
                files: "",
                blobPath: "",
                fileExtension: ""
              }
            }
          };

          return {
            ...prevData,
            ...(addS3Path && {
              deleteS3path: [...prevData.deleteS3path, s3path]
            }),
            lessonUnits: updatedUnits,
          };
        });
      } else {
        updateLessonMedia(addS3Path);
      }
    };

    setConfirmationPopupData({
      title: `Are you sure you want to delete ${displayNames[objectName] || objectName}?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: () => {
        setShow(false);

        const isMatch = s3path === file;
        const isUnit = objectName === "desktop" || objectName === "badge";

        updateWithOptionalDelete(objectName, isUnit, isMatch);
      },
      onCancel: handleClose,
    });
  };


  const handleUnitInputChanges = (event: any, index: number) => {
    const { name, value, files } = event.target;

    if (name === "unitName") {
      setLessonData((prevData) => {
        const updatedSubjects = [...prevData.lessonUnits];
        updatedSubjects[Number(index)].name = value;

        return {
          ...prevData,
          lessonUnits: updatedSubjects,
        };
      })

    } else if (name === "unitLevel") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            level: value > 0 ? value : 0
          };
        }
        return {
          ...prevData,
          lessonUnits: updatedlessonUnits,
        };
      });
    } else if (name === "unitReward") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            unitReward: value > 0 ? value : 0
          };
        }
        return {
          ...prevData,
          lessonUnits: updatedlessonUnits,
        };
      });
    } else if (name === "unitStatus") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            isActive: value
          };
        }
        return {
          ...prevData,
          lessonUnits: updatedlessonUnits,
        };
      });
    }
    else if (name === "newUnitName") {
      setLessonData((prevData) => {
        const updatedSubjects = [...prevData.lessonNewUnits];
        updatedSubjects[Number(index)].name = value;

        return {
          ...prevData,
          lessonNewUnits: updatedSubjects,
        };
      })
    } else if (name === "newUnitLevel") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonNewUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            level: value > 0 ? value : 0
          };
        }
        return {
          ...prevData,
          lessonNewUnits: updatedlessonUnits,
        };
      });
    } else if (name === "newUnitReward") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonNewUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            unitReward: value > 0 ? value : 0
          };
        }
        return {
          ...prevData,
          lessonNewUnits: updatedlessonUnits,
        };
      });
    } else if (name === "newUnitStatus") {
      setLessonData((prevData) => {
        const updatedlessonUnits = [...prevData.lessonNewUnits];
        if (updatedlessonUnits[index]) {
          updatedlessonUnits[index] = {
            ...updatedlessonUnits[index],
            isActive: value
          };
        }
        return {
          ...prevData,
          lessonNewUnits: updatedlessonUnits,
        };
      });
    }
  }

  const checkUnitName = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (lessonData.id && value && value.trim() !== "") {
      await checkUnitNameExist(lessonData.id, value).then((checkUnitNameExistResponse) => {
        const { message, statusCode } = checkUnitNameExistResponse;
        if (statusCode === 409) {
          setMessage({
            ...message,
            errorMessage: [message]
          })
        }

      })

    } else {
      if (lessonData.lessonUnits.length > 1) {
        // Check for duplicate unit names when lessonData.id does not exist
        const unitNames = new Set<string>();

        for (const unit of lessonData.lessonUnits) {
          const unitName = unit.name?.trim();
          if (unitName) {
            if (unitNames.has(unitName)) {
              setMessage({
                ...message,
                errorMessage: [`Duplicate unit name found: ${unitName}`],
              });
              return false;
            }
            unitNames.add(unitName);
          }
        }
      }
    }
  }


  const handleAddUnit = () => {

    const getValidationErrors = (unitArray: typeof lessonData.lessonUnits) => {
      let errors: string[] = [];

      if (unitArray.length === 0) return errors;

      const lastEntry = unitArray[unitArray.length - 1];

      if (lastEntry.name.trim() === "") errors.push("Unit Name is required.");
      if (!(lastEntry.unitMedia.desktop.files instanceof File)) errors.push("Banner file is required.");
      if (!lastEntry.level || Number(lastEntry.level) < 1) errors.push("Level is required.");

      setMessage((prev) => ({
        ...prev,
        errorMessage: errors
      }));

      return errors;
    };

    setLessonData((prevState) => {
      const targetArray = lessonData.id ? prevState.lessonNewUnits : prevState.lessonUnits;
      const validationErrors = getValidationErrors(targetArray);

      if (validationErrors.length > 0) {
        setMessage({
          ...message,
          errorMessage: validationErrors
        })
        return prevState;
      }

      const newUnit = {
        id: "",
        name: "",
        level: "",
        unitMedia: {
          desktop: { files: "", blobPath: "", fileExtension: "" },
          badge: { files: "", blobPath: "", fileExtension: "" }
        },
        unitReward: 0,
        isActive: ""
      };

      return lessonData.id
        ? { ...prevState, lessonNewUnits: [...prevState.lessonNewUnits, newUnit] }
        : { ...prevState, lessonUnits: [...prevState.lessonUnits, newUnit] };
    });
  };



  const handleDeleteUnit = async (unit: any, index: number, label?: string) => {
    setShow(true);
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${unit.name}`,
      message: "This action cannot be undo",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
        try {
          if (label) {
            if (label === "newUnit") {
              const updatedLessonNewUnits = [...lessonData.lessonNewUnits];
              updatedLessonNewUnits.splice(index, 1);
              setLessonData({
                ...lessonData,
                lessonNewUnits: updatedLessonNewUnits
              })
            } else if (label === "oldUnit") {
              const updatedLessonUnits = [...lessonData.lessonUnits];
              updatedLessonUnits.splice(index, 1);
              setLessonData({
                ...lessonData,
                lessonUnits: updatedLessonUnits
              })
            }
          } else {
            await deleteUnitByID(unit.id, access_token).then((deletedUnitResponse: any) => {
              const { data, statusCode } = deletedUnitResponse;
              if (statusCode === 200) {
                const updatedEntries = [...lessonData.lessonUnits];
                updatedEntries.splice(index, 1);
                if (updatedEntries.length > 0) {
                  setLessonData({
                    ...lessonData,
                    lessonUnits: updatedEntries
                  })
                } else {
                  setLessonData({
                    ...lessonData,
                    lessonUnits: updatedEntries,
                    lessonNewUnits: [{
                      id: "",
                      name: "",
                      level: "",
                      unitMedia: {
                        desktop: {
                          files: "",
                          blobPath: "",
                          fileExtension: ""
                        },
                        badge: {
                          files: "",
                          blobPath: "",
                          fileExtension: ""
                        }
                      },
                      unitReward: 0,
                      isActive: ""
                    }]
                  })
                }
                setMessage({
                  ...message,
                  successMessage: "Unit deleted successfully!"
                });
              } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage({
                  ...message,
                  failureMessage: "Authorization token expired. Try again!"
                })
              }
            })
          }

        } catch (error: any) {
          console.error("Error deleting unit 2 :: ", error);

        } finally {
          setTimeout(() => {
            setMessage((prev => {
              const updatedData = { ...prev };
              updatedData.errorMessage = prev.errorMessage;
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        }
      },
      onCancel: handleClose
    })

  };



  const handleUnitMedia = (event: React.ChangeEvent<HTMLInputElement>, index: number, unitType: string) => {
    const { name, files } = event.target;
    if (!files || files.length === 0) return;

    const file = files?.[0];
    if (lessonData.id) {
      if (unitType === "addedUnit") {
        if (files && (file.type.startsWith("image/"))) {
          if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
            if (checkFileLimit(file)) {
              setLessonData((prevLessonData) => {
                const updatedLessonUnits = [...prevLessonData.lessonUnits];
                updatedLessonUnits[index] = {
                  ...updatedLessonUnits[index],
                  unitMedia: {
                    ...updatedLessonUnits[index].unitMedia,
                    [name]: {
                      files: files[0],
                      blobPath: URL.createObjectURL(files[0]),
                      fileExtension: files?.[0].name.split('.').pop(),
                    }
                  }
                };

                return {
                  ...prevLessonData,
                  lessonUnits: updatedLessonUnits,
                };
              });
            } else {
              setMessage({
                ...message,
                errorMessage: ['File Size Exceed. Try to upload within the size limit.']
              });
              return;
            }
          } else {
            setMessage({
              ...message,
              errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
            });
            return;
          }

        }
      } else {
        if (files && (files?.[0].type.startsWith("image/"))) {

          if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
            if (checkFileLimit(file)) {
              setLessonData((prevLessonData) => {
                const updatedLessonUnits = [...prevLessonData.lessonNewUnits];
                updatedLessonUnits[index] = {
                  ...updatedLessonUnits[index],
                  unitMedia: {
                    ...updatedLessonUnits[index].unitMedia,
                    [name]: {
                      files: files[0],
                      blobPath: URL.createObjectURL(files[0]),
                      fileExtension: files?.[0].name.split('.').pop(),
                    }
                  }
                };

                return {
                  ...prevLessonData,
                  lessonNewUnits: updatedLessonUnits,
                };
              });
            } else {
              setMessage({
                ...message,
                errorMessage: ['File Size Exceed. Try to upload within the size limit.']
              });
              return;
            }
          } else {
            setMessage({
              ...message,
              errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
            });
            return;
          }

        }
      }

    } else {
      if (files && (file.type.startsWith("image/"))) {
        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            setLessonData((prevLessonData) => {
              const updatedLessonUnits = [...prevLessonData.lessonUnits];
              updatedLessonUnits[index] = {
                ...updatedLessonUnits[index],
                unitMedia: {
                  ...updatedLessonUnits[index].unitMedia,
                  [name]: {
                    files: files[0],
                    blobPath: URL.createObjectURL(files[0]),
                    fileExtension: files?.[0].name.split('.').pop(),
                  }
                }
              };

              return {
                ...prevLessonData,
                lessonUnits: updatedLessonUnits,
              };
            });
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }
        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
          });
          return;
        }

      }
    }

  };


  const handleMediaFiles = (event: React.ChangeEvent<any>) => {
    const { name, files } = event.target;
    if (!files || files.length === 0) return;

    const file = files?.[0];


    const fileType = file.type;
    const isImage = fileType.startsWith("image/");
    const isVideo = fileType.startsWith("video/");
    const isAudio = fileType.startsWith("audio/");
    const fileExtension = file.name.toLowerCase().split('.').pop();
    const blobPath = URL.createObjectURL(file);

    if (isImage) {
      if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
        if (checkFileLimit(file)) {
          setLessonData({
            ...lessonData,
            lessonMedia: {
              ...lessonData.lessonMedia,
              [name]: { files: file, blobPath, fileExtension }
            }
          })
        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }
      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
        });
        return;
      }



    } else if (isAudio) {
      if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
        if (checkFileLimit(file)) {
          setLessonData({
            ...lessonData,
            lessonMedia: {
              ...lessonData.lessonMedia,
              IntroAudio: { files: file, blobPath, fileExtension }
            }
          })
        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }
      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
        });
        return;
      }
    } else if (isVideo) {
      if (file && (file.name.toLowerCase().endsWith('.mp4') || file.name.toLowerCase().endsWith('.webm'))) {
        if (checkFileLimit(file)) {

          setLessonData({
            ...lessonData,
            lessonMedia: {
              ...lessonData.lessonMedia,
              IntroVideo: { files: file, blobPath, fileExtension }
            }
          })
        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }
      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported audio format. Please upload MP4, or WEBP']
        });
        return;
      }
    }


  }



  const handleDropdown = async (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, id: string, nameValue: string) => {
    const { name, value } = event.target;

    if (name === "lessonTribe" || name === "lessonSubject" || name === "lessonGrade") {
      if (lessonData.lessonStatus === "1") {
        setMessage({
          ...message,
          errorMessage: [
            "Lesson status is already in published state. Please unpublish it first to allow changes.",
          ],
        });
      } else {
        if (name === "lessonTribe") {
          setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          setLessonData((prevData) => ({
            ...prevData,
            lessonSubject: { id: "", name: "" },
            lessonGrade: { id: "", name: "" },
          }));

          try {
            await getTribeById(id, access_token).then((tribeResponse) => {

              const { data, statusCode } = tribeResponse;

              if (statusCode === 200) {
                setLessonData((prevData) => ({
                  ...prevData,
                  lessonTribe: { id: data.id, name: data.name },
                }));
                setDropDownList({
                  ...dropDownList,
                  subject: data.subject_id.map((subject: any) => ({
                    id: subject.id,
                    name: subject.name,
                  })),
                });
              }
            });

          } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message,
              });
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again",
              });
            }
          } finally {
            setTimeout(() => {
              setMessage((prev => {
                const updatedData = { ...prev };
                updatedData.errorMessage = prev.errorMessage;
                updatedData.failureMessage = "";
                updatedData.successMessage = ""
                return updatedData
              }))

            }, 2500)
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          }
        } else {
          setLessonData({
            ...lessonData,
            [event.target.name]: { id: id, name: nameValue },
          });
        }
      }
    } else {
      setLessonData({
        ...lessonData,
        [name]: value,
      });
    }
  };




  const validateForm = async () => {
    console.log("Validating form...", lessonData);
    const { lessonName, lessonDescription, badgeDescription, lessonIntroText, lessonTribe, lessonSubject, lessonGrade, lessonMedia, lessonNewUnits, lessonUnits, lessonStatus } = lessonData;

    const errorMessages: string[] = [];


    const isMediaValid = (media: any) => media && media.files;

    const allUnits = [...lessonUnits, ...lessonNewUnits];
    if (!lessonTribe?.name?.trim()) errorMessages.push("Tribe is required.");
    if (!lessonSubject?.name?.trim()) errorMessages.push("Subject is required.");

    if (!lessonGrade?.name?.trim()) errorMessages.push("Grade is required.");
    // General validations
    if (!lessonName?.trim()) errorMessages.push("Lesson name is required.");
    // if (!lessonStatus) errorMessages.push("Lesson status is required.");

    if (!lessonIntroText.replace(/<[^>]*>/g, '').trim()) {
      errorMessages.push(`Lesson Video Intro Text is required.`);
    }
    if (!lessonDescription.replace(/<[^>]*>/g, '').trim()) {
      errorMessages.push(`Lesson Description is required.`);
    }
    if (!isMediaValid(lessonMedia.DesktopBanner)) errorMessages.push("Banner is missing.");
    if (!isMediaValid(lessonMedia.BadgeIcon)) errorMessages.push("Badge is missing.");
    if (!badgeDescription.replace(/<[^>]*>/g, '').trim()) {
      errorMessages.push(`Badge Description is required.`);
    }

    // if (!isMediaValid(lessonMedia.IntroAudio)) errorMessages.push("Voice Over Audio is missing.");
    if (!isMediaValid(lessonMedia.IntroVideo)) errorMessages.push("Lesson Video is missing.");

    if (!isMediaValid(lessonMedia.Thumbnail)) errorMessages.push("Lesson Video Thumbnail is missing.");


    // Unit validations
    allUnits.forEach((unit, index) => {
      const unitIndex = index + 1;
      const hasName = !!unit.name?.trim();
      const hasDesktopBanner = !!unit.unitMedia?.desktop?.files;
      const hasLevel = !!unit.level;

      const unitLabel = hasName ? unit.name.trim() : `Unit ${unitIndex}`;

      if (index === 0) {
        if (!hasName || !hasDesktopBanner || !hasLevel) {
          const missing: string[] = [];

          if (!hasName) missing.push("name");
          if (!hasDesktopBanner) missing.push("desktop banner image");
          if (!hasLevel) missing.push("level");

          if (missing.length > 0) {
            errorMessages.push(
              `${unitLabel}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} missing.`
            );
          }
        }
      } else {
        if (!hasName || !hasDesktopBanner || !hasLevel) {
          const missing: string[] = [];

          if (!hasName) missing.push("name");
          if (!hasDesktopBanner) missing.push("desktop banner image");
          if (!hasLevel) missing.push("level");

          if (missing.length > 0) {
            errorMessages.push(
              `${unitLabel}: ${missing.join(", ")} ${missing.length < 2 ? "is" : "are"} missing.`
            );
          }
        }
      }
    });


    if (!lessonStatus.trim()) errorMessages.push("Lesson Status is required.");


    // If any error messages exist, display them and exit
    if (errorMessages.length > 0) {
      setMessage({
        ...message,
        errorMessage: errorMessages
      });
      return false;
    }

    try {
      const checkLessonNameResponse = await checkLessonNameExist(lessonData.id, lessonData.lessonGrade.id, lessonData.lessonName, lessonData.lessonTribe.id);
      const { message, statusCode } = checkLessonNameResponse;

      if (statusCode === 409) {
        setMessage({
          ...message,
          errorMessage: [message]
        });
        return false;
      }

      if (lessonData.id) {
        const checkPromises = lessonNewUnits.map(async (unit: UnitDataType) => {
          const res = await checkUnitNameExist(lessonData.id, unit.name);
          if (res.statusCode === 409) {
            setMessage({
              ...message,
              errorMessage: [res.message]
            });
            return false;
          }
          return true;
        });

        const results = await Promise.all(checkPromises);
        return results.every(r => r);
      } else {
        const unitNames = new Set<string>();
        for (const unit of lessonUnits) {
          const name = unit.name?.trim();
          if (name) {
            if (unitNames.has(name)) {
              setMessage({
                ...message,
                errorMessage: [`Duplicate unit name found: ${name}`]
              });
              return false;
            }
            unitNames.add(name);
          }
        }
        return true;
      }
    } catch (error: any) {
      //console.error("Error in validateForm: ", error);
      return false;
    }

  };




  const handleSubmit = async () => {
    if (await validateForm()) {
      setShow(true)
      setConfirmationPopupData({
        title: "Are you sure you want to submit?",
        message: "This will submit the lesson data to the server.",
        descriptions: "",
        acceptText: "Submit",
        cancelText: "Cancel",
        onAccept: async () => {
          setShow(false)
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
          try {

            const formData = new FormData();
            formData.append("name", lessonData.lessonName)
            formData.append("tribe_id", lessonData.lessonTribe.id);
            formData.append("subject_id", lessonData.lessonSubject.id);
            formData.append("description", lessonData.lessonDescription);

            formData.append("badge_description", lessonData.badgeDescription);
            formData.append("intro_text", lessonData.lessonIntroText);
            formData.append("grade_id", lessonData.lessonGrade.id);
            formData.append("reward", String(lessonData.lessonReward));
            formData.append("active", lessonData.lessonStatus);
            if (lessonData.id) {
              formData.append('id', lessonData.id);

              if (lessonData.lessonMedia.DesktopBanner.files instanceof File) {
                formData.append("bannerImage_desk", lessonData.lessonMedia.DesktopBanner.files)
                formData.append("bannerImage_mobile", lessonData.lessonMedia.DesktopBanner.files)
              }
              if (lessonData.lessonMedia.BadgeIcon.files instanceof File) {
                formData.append("badgeIcon", lessonData.lessonMedia.BadgeIcon.files);
              }
              if (lessonData.lessonMedia.IntroVideo.files instanceof File) {
                formData.append("lesson_video", lessonData.lessonMedia.IntroVideo.files)
              }
              if (lessonData.lessonMedia.IntroAudio.files instanceof File) {
                formData.append("lesson_audio", lessonData.lessonMedia.IntroAudio.files)
              }

              if (lessonData.lessonMedia.Thumbnail.files instanceof File) {
                formData.append("lesson_thumbnail", lessonData.lessonMedia.Thumbnail.files);
              }


              let newUnits: any[] = [];
              for (var i = 0; i < lessonData.lessonNewUnits.length; i++) {
                let newLessonUnit = lessonData.lessonNewUnits[i];
                if (newLessonUnit.name) {
                  newUnits.push({ name: newLessonUnit.name, description: "", level: newLessonUnit.level, reward: String(0), isActive: lessonData.lessonStatus });
                  formData.append("files", newLessonUnit.unitMedia.desktop.files, `unit_new_image_desk_${i}.${newLessonUnit.unitMedia.desktop.fileExtension}`);
                  formData.append("files", newLessonUnit.unitMedia.desktop.files, `unit_new_image_mobile_${i}.${newLessonUnit.unitMedia.desktop.fileExtension}`);
                }
              }
              let updatedExistingUnits: any[] = [];
              const seenIds = new Set(); // To track already processed IDs

              for (let j = 0; j < lessonData.lessonUnits.length; j++) {
                let existingUnit = lessonData.lessonUnits[j];
                if (!seenIds.has(existingUnit.id)) {
                  updatedExistingUnits.push({ id: existingUnit.id, name: existingUnit.name, reward: String(0), isActive: lessonData.lessonStatus });
                  seenIds.add(existingUnit.id); // Mark this ID as processed
                }

                if (existingUnit.unitMedia.desktop.files instanceof File) {
                  formData.append("files", existingUnit.unitMedia.desktop.files, `unit_image_desk_${j}.${existingUnit.unitMedia.desktop.fileExtension}`);
                  formData.append("files", existingUnit.unitMedia.desktop.files, `unit_image_mobile_${j}.${existingUnit.unitMedia.desktop.fileExtension}`);
                }

                if (existingUnit.unitMedia.badge.files instanceof File) {
                  formData.append("files", existingUnit.unitMedia.badge.files, `unit_image_badge_${j}.${existingUnit.unitMedia.badge.fileExtension}`);
                }
              }

              if (lessonData.deleteS3path.length > 0) {
                formData.append("removeFiles", JSON.stringify(lessonData.deleteS3path.map((s3path: string) => ({ path: s3path }))));
              }

              if (newUnits.length > 0) {
                formData.append("newUnits", JSON.stringify(newUnits));
              }

              if (updatedExistingUnits.length > 0) {
                formData.append("units", JSON.stringify(updatedExistingUnits));
              }

              try {
                await updateLesson(formData, access_token).then((updateLessonResponse) => {
                  const { data, statusCode } = updateLessonResponse;
                  console.log("Update Lesson Response :: ", updateLessonResponse, data, statusCode);
                  if (statusCode === 200) {
                    setShow(true)


                    setMessage({
                      ...message,
                      successMessage: "Lesson updated successfully!"
                    });

                    const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

                    const getMediaObject = (path: string) => ({
                      files: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
                      blobPath: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
                      fileExtension: getFileExtension(path),
                    });

                    setLessonData(prev => ({
                      ...prev,
                      id: data.id,
                      lessonName: data.name,
                      lessonTribe: { id: data.tribe_id.id, name: data.tribe_id.name },
                      lessonSubject: data.subject_id ? { id: data.subject_id.id, name: data.subject_id.name } : { id: "", name: "" },
                      lessonGrade: { id: data.grade_id.id, name: data.grade_id.name },
                      deleteS3path: [],
                      lessonIntroText: data.intro_text,
                      lessonDescription: data.description,
                      badgeDescription: data.badge_description,
                      lessonMedia: {
                        DesktopBanner: getMediaObject(data.bannerImage_path_desk ? data.bannerImage_path_desk : ""),
                        MobileBanner: getMediaObject(data.bannerImage_path_mobile ? data.bannerImage_path_mobile : ""),
                        IntroAudio: getMediaObject(data.lesson_audio_path ? data.lesson_audio_path : ""),
                        IntroVideo: getMediaObject(data.lesson_video_path ? data.lesson_video_path : ""),
                        BadgeIcon: getMediaObject(data.badgeIcon ? data.badgeIcon : ""),
                        Thumbnail: getMediaObject(data.lesson_thumbnail ? data.lesson_thumbnail : "")
                      },
                      lessonNewUnits: data.units.length > 0 ? [] : [{
                        id: "",
                        name: "",
                        level: "",
                        unitMedia: {
                          desktop: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          },
                          badge: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          }
                        },
                        unitReward: 0,
                        isActive: ""
                      }],
                      lessonUnits: data.units.map((unit: any) => ({
                        id: unit.id,
                        name: unit.name,
                        level: unit.level,
                        unitMedia: {
                          desktop: getMediaObject(unit.bannerImage_path_desk ? unit.bannerImage_path_desk : ""),
                          badge: getMediaObject(unit.badge_image ? unit.badge_image : ""),

                        },
                        unitReward: Number(unit.reward) ? Number(unit.reward) : 0,
                        isActive: String(unit.isActive)
                      })),
                      lessonReward: Number(data.reward),
                      lessonStatus: String(data.isActive)

                    }))

                    setConfirmationPopupData({
                      title: "Your lesson updated!",
                      message: "",
                      descriptions:
                        lessonData.lessonStatus === "2" ? "You can now preview your lesson." : (lessonData.lessonStatus === "0" ? "Note : To preview a lesson, ensure it is set to Draft status, as only draft lessons can be previewed. If your lesson is ready for all students, update the lesson status to Published from the dropdown." : "Your lesson is now published and visible to all students."),
                      acceptText: lessonData.lessonStatus === "0" ? "Edit Lesson" : "Preview Lesson",
                      cancelText: "Back to Lesson List",
                      onAccept: () => {
                        setShow(false);
                        if (lessonData.lessonStatus !== "0") {
                          handlePreview(lessonData.id);
                        }
                      },

                      onCancel: () => {
                        setShow(false);
                        setOpenLessonPage(false);
                        getLesson(indexOfFirstItem);
                      },
                    });



                  } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({
                      ...message,
                      failureMessage: "Authorization token expired. Try again!"
                    })
                  }
                })
              } catch (error: any) {
                if (error.response && error.response.data && typeof error.response.data === "string") {
                  setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                  })
                } else {
                  setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                  })
                }
              } finally {

                setTimeout(() => {
                  setMessage((prev => {
                    const updatedData = { ...prev };
                    updatedData.errorMessage = prev.errorMessage;
                    updatedData.failureMessage = "";
                    updatedData.successMessage = ""
                    return updatedData
                  }))

                }, 2500)
                setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
              }

            } else {
              formData.append('units', JSON.stringify(lessonData.lessonUnits.filter((unit: UnitDataType) => unit.name && unit.name.trim() !== "").map((unit: UnitDataType) => ({ name: unit.name, description: "", reward: String(0), level: unit.level, isActive: lessonData.lessonStatus }))));
              if (lessonData.lessonMedia.DesktopBanner.files instanceof File) {
                formData.append("bannerImage_desk", lessonData.lessonMedia.DesktopBanner.files)
                formData.append("bannerImage_mobile", lessonData.lessonMedia.DesktopBanner.files)
              }
              if (lessonData.lessonMedia.BadgeIcon.files instanceof File) {
                formData.append("badgeIcon", lessonData.lessonMedia.BadgeIcon.files);
              }
              if (lessonData.lessonMedia.IntroVideo.files instanceof File) {
                formData.append("lesson_video", lessonData.lessonMedia.IntroVideo.files)
              }
              if (lessonData.lessonMedia.IntroAudio.files instanceof File) {
                formData.append("lesson_audio", lessonData.lessonMedia.IntroAudio.files)
              }

              if (lessonData.lessonMedia.Thumbnail.files instanceof File) {
                formData.append("lesson_thumbnail", lessonData.lessonMedia.Thumbnail.files);
              }

              for (var k = 0; k < lessonData.lessonUnits.length; k++) {
                if (lessonData.lessonUnits[k].name) {
                  formData.append("files", lessonData.lessonUnits[k].unitMedia.desktop.files, `unit_image_desk_${k}.${lessonData.lessonUnits[k].unitMedia.desktop.fileExtension}`);
                  formData.append("files", lessonData.lessonUnits[k].unitMedia.desktop.files, `unit_image_mobile_${k}.${lessonData.lessonUnits[k].unitMedia.desktop.fileExtension}`);
                  // formData.append("files", lessonData.lessonUnits[k].unitMedia.badge.files, `unit_image_badge_${k}.${lessonData.lessonUnits[k].unitMedia.badge.fileExtension}`);
                }
              }

              try {
                await addNewLesson(formData, access_token).then((newLessonResponse: any) => {
                  const { data, statusCode } = newLessonResponse;
                  if (statusCode === 200) {
                    const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

                    const getMediaObject = (path: string) => ({
                      files: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
                      blobPath: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
                      fileExtension: getFileExtension(path),
                    });

                    setLessonData(prev => ({
                      ...prev,
                      id: data.id,
                      lessonName: data.name,
                      lessonTribe: { id: data.tribe_id.id, name: data.tribe_id.name },
                      lessonSubject: data.subject_id ? { id: data.subject_id.id, name: data.subject_id.name } : { id: "", name: "" },
                      lessonGrade: { id: data.grade_id.id, name: data.grade_id.name },
                      deleteS3path: [],
                      lessonIntroText: data.intro_text,
                      lessonDescription: data.description,
                      badgeDescription: data.badge_description,
                      lessonMedia: {
                        DesktopBanner: getMediaObject(data.bannerImage_path_desk ? data.bannerImage_path_desk : ""),
                        MobileBanner: getMediaObject(data.bannerImage_path_mobile ? data.bannerImage_path_mobile : ""),
                        IntroAudio: getMediaObject(data.lesson_audio_path ? data.lesson_audio_path : ""),
                        IntroVideo: getMediaObject(data.lesson_video_path ? data.lesson_video_path : ""),
                        BadgeIcon: getMediaObject(data.badgeIcon ? data.badgeIcon : ""),
                        Thumbnail: getMediaObject(data.lesson_thumbnail ? data.lesson_thumbnail : "")
                      },
                      lessonNewUnits: data.units.length > 0 ? [] : [{
                        id: "",
                        name: "",
                        level: "",
                        unitMedia: {
                          desktop: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          },
                          badge: {
                            files: "",
                            blobPath: "",
                            fileExtension: ""
                          }
                        },
                        unitReward: 0,
                        isActive: ""
                      }],
                      lessonUnits: data.units.map((unit: any) => ({
                        id: unit.id,
                        name: unit.name,
                        level: unit.level,
                        unitMedia: {
                          desktop: getMediaObject(unit.bannerImage_path_desk ? unit.bannerImage_path_desk : ""),
                          badge: getMediaObject(unit.badge_image ? unit.badge_image : ""),

                        },
                        unitReward: Number(unit.reward) ? Number(unit.reward) : 0,
                        isActive: String(unit.isActive)
                      })),
                      lessonReward: Number(data.reward),
                      lessonStatus: String(data.isActive)

                    }))
                    setShow(true)

                    setConfirmationPopupData({
                      title: "Your lesson created!",
                      message: "",
                      descriptions:
                        lessonData.lessonStatus === "2" ? "You can now preview your lesson." : (lessonData.lessonStatus === "0" ? "Note : To preview a lesson, ensure it is set to Draft status, as only draft lessons can be previewed. If your lesson is ready for all students, update the lesson status to Published from the dropdown." : "Your lesson is now published and visible to all students."),
                      acceptText: lessonData.lessonStatus === "0" ? "Edit Lesson" : "Preview Lesson",
                      cancelText: "Back to Lesson List",
                      onAccept: () => {
                        setShow(false);
                        if (lessonData.lessonStatus !== "0") {
                          handlePreview(lessonData.id);
                        }
                      },

                      onCancel: () => {
                        setShow(false);
                        setOpenLessonPage(false);
                        getLesson(indexOfFirstItem);
                      },
                    });
                    setMessage({
                      ...message,
                      successMessage: "Lesson added successfully!"
                    });
                  } else if (statusCode === 401) {
                    getAuthorizedToken();
                    setMessage({
                      ...message,
                      failureMessage: "Authorization token expired. Try again!"
                    })
                  }
                })
              } catch (error: any) {
                if (error.response && error.response.data && typeof error.response.data === "string") {
                  setMessage({
                    ...message,
                    failureMessage: error.response.data.message
                  })
                } else {
                  setMessage({
                    ...message,
                    failureMessage: "Something went wrong. Please try again"
                  })
                }
              } finally {
                // setOpenLessonPage(false)
                setTimeout(() => {
                  setMessage((prev => {
                    const updatedData = { ...prev };
                    updatedData.errorMessage = prev.errorMessage;
                    updatedData.failureMessage = "";
                    updatedData.successMessage = ""
                    return updatedData
                  }))

                }, 2500)
                setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
                // getLesson(indexOfFirstItem);
              }
            }
          } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message
              })
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again"
              })
            }

          } finally {
            setTimeout(() => {
              setMessage((prev => {
                const updatedData = { ...prev };
                updatedData.errorMessage = prev.errorMessage;
                updatedData.failureMessage = "";
                updatedData.successMessage = ""
                return updatedData
              }))

            }, 2500)
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          }
        },
        onCancel: handleClose
      })
    }
  }


  const handleCancel = () => {
    setShow(true);
    setConfirmationPopupData({
      title: "Are you sure you want to cancel?",
      message: "This action will not be undo",
      descriptions: "",
      acceptText: "Ok",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setOpenLessonPage(false);
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        getLesson(indexOfFirstItem);
      },
      onCancel: handleClose
    })

  }



  const getLesson = async (firstIndex: number) => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    try {
      await getAllLesson(String(firstIndex), String(itemsPerPage), access_token).then((allLessonResponse: any) => {
        const { data, statusCode } = allLessonResponse;
        if (statusCode === 200) {
          handleLessonData(data);
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      })
    } catch (error: any) {
      console.error('Error fetching lesson data:', error);
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }

    } finally {
      setTimeout(() => {
        setMessage((prev => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };

  const handleLessonData = (tableLessonData: any) => {
    const { lessons, count } = tableLessonData
    setTotalCount(count)

    let formattedData: TableLessonDataType[] = lessons.map((lesson: any) => {
      if (lesson.tribe_id) {
        return {
          id: lesson.id,
          name: lesson.name,
          unit: lesson.units && lesson.units.length > 0 ? lesson.units.length : 0,
          grade: { gradeId: lesson.grade_id.id, gradeName: lesson.grade_id.name },
          status: lesson.isActive === 1 ? "PUBLISHED" : (lesson.isActive === 2 ? "DRAFT" : "UNPUBLISHED"),
          tribe: lesson.tribe_id.name,
        };
      }

      return null;

    }).filter((item: any) => item !== null); // remove null values if needed

    setLableLessonData(formattedData); // Set the formatted data
  }


  const handlePagination = async (pageNumber: number, direction: string) => {
    if (pageNumber < 1 || pageNumber > Math.ceil(lessonCount / itemsPerPage)) {
      return;
    }

    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))

    if (direction === "right") {
      if (pageNumber <= Math.ceil(lessonCount / itemsPerPage)) {
        setCurrentPage(pageNumber);
      }
    } else {
      if (pageNumber >= 1) {
        setCurrentPage(pageNumber);
      }
    }

    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
  };

  const fetchData = async () => {
    if (activeFilter.status || activeFilter.grade.id || searchtext || startDate || endDate) {
      try {
        await searchLesson(searchtext, activeFilter.status, activeFilter.grade.id, formatLocalDate(startDate), formatLocalDate(endDate), String(indexOfFirstItem), String(indexOfLastItem), access_token).then((searchTribeData) => {
          const { data, statusCode } = searchTribeData;
          if (statusCode === 200) {
            handleLessonData(data);
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        });

      } catch (error: any) {
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            ...message,
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            ...message,
            failureMessage: "Something went wrong. Please try again"
          })
        }
      } finally {
        setTimeout(() => {
          setMessage((prev => {
            const updatedData = { ...prev };
            updatedData.errorMessage = prev.errorMessage;
            updatedData.failureMessage = "";
            updatedData.successMessage = ""
            return updatedData
          }))

        }, 2500)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      }
    } else {
      getLesson(indexOfFirstItem);
    }
  };

  const getAllGrade = async () => {
    const gradeResponse = await getGrade();

    setDropDownList((prevState: any) => ({
      ...prevState,
      grade: gradeResponse.data.data.map((grade: any) => ({
        id: grade.id,
        name: grade.name
      }))
    }));
  }

  useEffect(() => {
    fetchData();
    getAllGrade();
  }, [currentPage]);

  useEffect(() => {
    if (openLessonPage) {
      const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = "Are you sure you want to leave? Your changes may not be saved.";
      };

      const handlePopState = () => {
        const confirmExit = window.confirm("Are you sure you want to go back? Your changes may not be saved.");
        if (!confirmExit) {
          // Restore the same state to prevent navigation
          window.history.pushState(null, "", window.location.href);
        }
      };

      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("popstate", handlePopState);

      // Push a new state when popup opens
      window.history.pushState(null, "", window.location.href);

      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("popstate", handlePopState);
      };
    }
  });



  const handleDelete = async (lesson: any) => {

    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${lesson.name} lesson?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
        try {
          await deleteLessonByID(lesson.id, access_token).then((deletedResponse: any) => {
            const { statusCode } = deletedResponse;
            if (statusCode === 200) {
              setMessage({
                ...message,
                successMessage: "Lesson Deleted Successfully!",
                failureMessage: "",
              });
              getLesson(indexOfFirstItem);


            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          })
        } catch (error: any) {
          console.error("Error in Delete :: ", error)
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again"
            })
          }

        } finally {
          setTimeout(() => {
            setMessage((prev => {
              const updatedData = { ...prev };
              updatedData.errorMessage = prev.errorMessage;
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        }
      },
      onCancel: handleClose,
    })

  }


  const formatLocalDate = (date: Date | null): string | null => {
    if (!date) return null; // Handle null case

    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset()); // Adjust for timezone shift

    return localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD
  };

  const handleFilter = (name: string, value: string | IdAndName) => {
    if (name === "status" && typeof value === "string") {
      setActiveFilter({
        ...activeFilter,
        status: value ? value : ""
      })

      setFilter(prev => ({
        ...prev,
        status: value === "1" ? "Published" : value === "2" ? "Draft" : value === "0" ? "Unpublished" : ""
      }));
    } else if (name === "grade" && typeof value === "object") {
      setActiveFilter(prev => ({
        ...prev,
        grade: value
      }));

      setFilter(prev => ({
        ...prev,
        grade: value.name
      }));
    } else if (name === "date") {
      setFilter({
        ...filter,
        dateFilter: ""
      })
      setStartDate(null)
      setEndDate(null)
    }
  };


  useEffect(() => {
    const handleSearch = async () => {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      setCurrentPage(1);
      if (startDate && endDate) {
        const lang = navigator.language || navigator.languages[0];
        setFilter({
          ...filter,
          dateFilter: `${startDate ? startDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""} - ${endDate ? endDate.toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : ""
            }`
        });
      }
      try {
        const searchTribeData = await searchLesson(searchtext, activeFilter.status, activeFilter.grade.id, (startDate && endDate) ? formatLocalDate(startDate) : null, (startDate && endDate) ? formatLocalDate(endDate) : null, String(indexOfFirstItem), String(indexOfLastItem), access_token);

        const { data, statusCode } = searchTribeData;

        if (statusCode === 200) {
          handleLessonData(data);
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      } catch (error: any) {
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            ...message,
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            ...message,
            failureMessage: "Something went wrong. Please try again"
          })
        }
      } finally {
        setTimeout(() => {
          setMessage((prev => {
            const updatedData = { ...prev };
            updatedData.errorMessage = prev.errorMessage;
            updatedData.failureMessage = "";
            updatedData.successMessage = ""
            return updatedData
          }))

        }, 2500)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      }
    }

    handleSearch()

  }, [searchtext, activeFilter.status, activeFilter.grade.id, startDate, endDate])


  const getInitialLessonData = () => ({
    id: "",
    lessonName: "",
    lessonTribe: { id: "", name: "" },
    lessonSubject: { id: "", name: "" },
    lessonGrade: { id: "", name: "" },
    deleteS3path: [],
    lessonDescription: '',
    lessonMedia: {
      DesktopBanner: emptyMedia(),
      MobileBanner: emptyMedia(),
      IntroVideo: emptyMedia(),
      IntroAudio: emptyMedia(),
      BadgeIcon: emptyMedia()
    },
    lessonNewUnits: [],
    lessonUnits: [getInitialUnit()],
    lessonReward: 0,
    lessonStatus: ""
  });

  const getInitialUnit = () => ({
    id: "",
    name: "",
    level: "",
    unitMedia: {
      desktop: emptyMedia(),
      badge: emptyMedia()
    },
    unitReward: 0,
    isActive: ""
  });

  const emptyMedia = () => ({
    files: "",
    blobPath: "",
    fileExtension: ""
  });

  const getMediaData = (path: string) => ({
    files: path,
    blobPath: path,
    fileExtension: path?.split('.').pop() || ""
  });

  const handleLessonError = (error: any) => {
    //console.error("Lesson 166", error);
    setMessage(prev => ({
      ...prev,
      failureMessage: error?.response?.data?.message || "Something went wrong. Please try again"
    }));
  };

  const clearMessageAfterDelay = () => {
    setTimeout(() => {
      setMessage(prev => ({
        ...prev,
        failureMessage: "",
        successMessage: "",
        errorMessage: prev.errorMessage
      }));
    }, 2500);
  };



  const handleEditBtn = async (lesson: TableLessonDataType) => {
    setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false }))
    setFilter({ status: "", dateFilter: "", grade: "" });
    setLessonData({
      id: "",
      lessonName: "",
      lessonTribe: { id: "", name: "" },
      lessonSubject: { id: "", name: "" },
      lessonGrade: { id: "", name: "" },
      deleteS3path: [],
      lessonDescription: "",
      lessonIntroText: "",
      badgeDescription: "",
      lessonMedia: {
        DesktopBanner: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        MobileBanner: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        IntroVideo: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        IntroAudio: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        BadgeIcon: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        Thumbnail: {
          files: "",
          blobPath: "",
          fileExtension: ""
        }
      },
      lessonNewUnits: [],
      lessonUnits: [
        {
          id: "",
          name: "",
          level: "",
          unitMedia: {
            desktop: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            badge: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },
          unitReward: 0,
          isActive: ""
        }],
      lessonReward: 0,
      lessonStatus: ""
    })
    setOpenLessonPage(true);

    try {
      await getLessonByID(lesson.id, access_token).then(async (lessonData) => {
        const { data, statusCode } = lessonData;
        if (statusCode === 200) {
          try {
            await getTribeById(data.tribe_id.id, access_token).then((tribeDataById: any) => {
              const { data, statusCode } = tribeDataById;
              if (statusCode === 200) {
                allDropDownData()
                setDropDownList({
                  ...dropDownList,
                  subject: data.subject_id.map((subject: any) => ({
                    id: subject.id,
                    name: subject.name
                  })),
                });
              } else if (statusCode === 401) {
                getAuthorizedToken()
                setMessage({
                  ...message,
                  failureMessage: "Authorization token expired. Try again!"
                })
              }

            });

            const gradeResponse = await getGrade();

            setDropDownList((prevState: any) => ({
              ...prevState,
              grade: gradeResponse.data.data.map((grade: any) => ({
                id: grade.id,
                name: grade.name
              }))
            }));
            const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

            const getMediaObject = (path: string) => ({
              files: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
              blobPath: path ? (data.id ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : path) : "",
              fileExtension: getFileExtension(path),
            });

            setLessonData({
              id: data.id,
              lessonName: data.name,
              lessonTribe: { id: data.tribe_id.id, name: data.tribe_id.name },
              lessonSubject: data.subject_id ? { id: data.subject_id.id, name: data.subject_id.name } : { id: "", name: "" },
              lessonGrade: { id: data.grade_id.id, name: data.grade_id.name },
              deleteS3path: [],
              lessonIntroText: data.intro_text,
              lessonDescription: data.description,
              badgeDescription: data.badge_description,
              lessonMedia: {
                DesktopBanner: getMediaObject(data.bannerImage_path_desk ? data.bannerImage_path_desk : ""),
                MobileBanner: getMediaObject(data.bannerImage_path_mobile ? data.bannerImage_path_mobile : ""),
                IntroAudio: getMediaObject(data.lesson_audio_path ? data.lesson_audio_path : ""),
                IntroVideo: getMediaObject(data.lesson_video_path ? data.lesson_video_path : ""),
                BadgeIcon: getMediaObject(data.badgeIcon ? data.badgeIcon : ""),
                Thumbnail: getMediaObject(data.lesson_thumbnail ? data.lesson_thumbnail : "")
              },
              lessonNewUnits: data.units.length > 0 ? [] : [{
                id: "",
                name: "",
                level: "",
                unitMedia: {
                  desktop: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  },
                  badge: {
                    files: "",
                    blobPath: "",
                    fileExtension: ""
                  }
                },
                unitReward: 0,
                isActive: ""
              }],
              lessonUnits: data.units.map((unit: any) => ({
                id: unit.id,
                name: unit.name,
                level: unit.level,
                unitMedia: {
                  desktop: getMediaObject(unit.bannerImage_path_desk ? unit.bannerImage_path_desk : ""),
                  badge: getMediaObject(unit.badge_image ? unit.badge_image : ""),

                },
                unitReward: Number(unit.reward) ? Number(unit.reward) : 0,
                isActive: String(unit.isActive)
              })),
              lessonReward: Number(data.reward),
              lessonStatus: String(data.isActive)
            })

          } catch (error: any) {
            console.error("Error fetching tribe data:", error);
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message
              })
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again"
              })
            }
          } finally {
            setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          }


        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      })
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setTimeout(() => {
        setMessage((prev => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }

  };



  const handleNewLesson = async () => {

    setLessonData({
      id: "",
      lessonName: "",
      lessonTribe: { id: "", name: "" },
      lessonSubject: { id: "", name: "" },
      lessonGrade: { id: "", name: "" },
      deleteS3path: [],
      lessonDescription: "",
      lessonIntroText: "",
      badgeDescription: "",
      lessonMedia: {
        DesktopBanner: { files: "", blobPath: "", fileExtension: "" },
        MobileBanner: { files: "", blobPath: "", fileExtension: "" },
        IntroVideo: { files: "", blobPath: "", fileExtension: "" },
        IntroAudio: { files: "", blobPath: "", fileExtension: "" },
        BadgeIcon: { files: "", blobPath: "", fileExtension: "" },
        Thumbnail: { files: "", blobPath: "", fileExtension: "" }
      },
      lessonNewUnits: [],
      lessonUnits: [{
        id: "",
        name: "",
        level: "",
        unitMedia: {
          desktop: { files: "", blobPath: "", fileExtension: "" },
          badge: { files: "", blobPath: "", fileExtension: "" }
        },
        unitReward: 0,
        isActive: ""
      }],
      lessonReward: 0,
      lessonStatus: ""
    });

    // Reset dropdown list
    setDropDownList({
      tribe: [],
      subject: [],
      grade: []
    });

    // Fetch dropdown data
    allDropDownData();

    try {
      const gradeResponse = await getGrade();

      setDropDownList((prevState: any) => ({
        ...prevState,
        grade: gradeResponse.data.data.map((grade: any) => ({
          id: grade.id,
          name: grade.name
        }))
      }));
    } catch (error: any) {
      console.error("Error fetching grades:", error);
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    }

    // Reset validation and open lesson page
    setOpenLessonPage(true);
    setFilter({ status: "", dateFilter: "", grade: "" });
    setStartDate(null);
    setEndDate(null);
  };


  const handlePreview = (lessonId: string) => {
    // alert("Lesson Id <> "+lessonId)
    // Open the child window — must be triggered by a direct user interaction
    const win = window.open(process.env.REACT_APP_REDIRECT_WINDOW, "_blank");

    if (!win) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Add the message listener immediately
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === process.env.REACT_APP_REDIRECT_WINDOW) {
        window.removeEventListener("message", handleMessage); // Clean up
      } else {
        console.warn("Message blocked from unknown origin:", event.origin);
      }
    };

    window.addEventListener("message", handleMessage);

    // Function to send message when the child window is ready
    const sendMessage = () => {
      try {
        if (win && typeof process.env.REACT_APP_REDIRECT_WINDOW === 'string') {
          win.postMessage({ accessToken: access_token, refreshToken: refresh_token, lessonId: lessonId }, process.env.REACT_APP_REDIRECT_WINDOW);
        } else {
          console.error("Invalid window reference or redirect window URL is not set");
        }

      } catch (error) {
        console.error("Error sending message:", error);
      }
    };

    // Try sending the message a few times to ensure it reaches
    let tries = 0;
    const interval = setInterval(() => {
      if (win.closed) {
        clearInterval(interval);
        return;
      }

      sendMessage();
      tries++;

      if (tries >= 3) {
        clearInterval(interval);
      }
    }, 1000);
  };




  return (
    <div className="dashboard d-flex">
      <Header />
      <div className="rightContainer">
        {message.successMessage && <SuccessPopup message={message.successMessage} />}
        {message.failureMessage && <FailurePoup message={message.failureMessage} />}
        {!openLessonPage ?
          <div>
            <div className="header-container">
              <h2 className="page-title text-center">Lessons</h2>
            </div>

            <div className="pCard">
              <div className="topAction align-items-center">
                <div className="dropdown statusDrop">
                  <button className="dropdown-toggle" type="button" id="dropdownMenuButtonStatus" data-bs-toggle="dropdown" aria-expanded="false">
                    {/* {activeFilter.status === "All" ? "Status" : activeFilter.status === "1" ? "Publish" : activeFilter.status === "0" ? "Inactive" : "Status"} */}
                    Status
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonStatus">
                    <li><button className={`dropdown-item`} name="status" onClick={() => handleFilter("status", "")}>All</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "1" ? "active" : ""}`} name="status" value="Published" onClick={() => handleFilter("status", "1")} >Published</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "2"} ? "active" : ""`} onClick={() => handleFilter("status", "2")}>Draft</button></li>
                    <li><button className={`dropdown-item ${activeFilter.status === "0" ? "active" : ""}`} name="status" value="Unpublished" onClick={() => handleFilter("status", "0")} >Unpublished</button></li>
                  </ul>

                  {filter.status &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.status}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("status", "")} /></span></span>
                  }

                  <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                    {/* {activeFilter.grade.id ? activeFilter.grade.name : "Grade"} */}
                    Grade
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                    <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => handleFilter("grade", { id: "", name: "" })} >
                      All
                    </button>
                    {dropDownList.grade.map((grade: IdAndName, index: number) => (
                      <li key={grade.id}>
                        <button className={`dropdown-item ${activeFilter.grade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => handleFilter("grade", { id: grade.id, name: grade.name })} >
                          {grade.name}
                        </button>
                      </li>
                    ))}
                  </ul>



                  {filter.grade &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.grade}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("grade", { id: "", name: "" })} /></span></span>
                  }


                  {filter.dateFilter &&
                    <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{filter.dateFilter}
                      <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => handleFilter("date", "")} /></span></span>
                  }
                </div>

                <div className="dropdown filter ms-auto">
                  <a className="dropdown-toggle" href="#blank" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                    <img src="./assets/images/filter.svg" alt="Filter" />
                  </a>
                  <div className="dropdown-menu p-3" onClick={(e) => e.stopPropagation()}>
                    <div className="mb-3">
                      <label htmlFor="startDate" className="form-label">
                        Start Date
                      </label>
                      <DatePicker id="startDate" selected={startDate} onChange={(date) => setStartDate(date)} className="form-control" placeholderText="Select Date" />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="endDate" className="form-label">
                        End Date
                      </label>
                      <DatePicker id="endDate" selected={endDate} onChange={handleEndDateChange} className="form-control" placeholderText="Select Date" />
                    </div>
                  </div>
                </div>
                <div className="searchInputDashboard">
                  <input type="text" placeholder="Search" name="searchText" value={searchtext} onChange={(e) => setSearchText(e.target.value)} />
                </div>

                <button className="btn add-btn btnPurple w-auto px-3" onClick={handleNewLesson} >+</button>

              </div>
              {loading.tableLoading ?
                <div className="d-flex align-items-center mt-5">
                  <div className="loader mx-auto"></div>
                </div> :
                tableLessonData.length > 0 ?
                  <div className="table-responsive">
                    <table className="table table-bordered" id="table_with_lessons_data">
                      <thead>
                        <tr>
                          <th className="text-start">LESSON</th>
                          <th className="text-center"># UNITS</th>
                          <th className="text-center">GRADE</th>
                          <th className="text-center">TRIBE</th>
                          <th className="text-center">STATUS</th>


                          <th className='text-center'>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableLessonData.map((lesson: TableLessonDataType) => (
                          <tr key={lesson.id}>
                            {/* Lesson with Tooltip */}
                            <td>
                              <span data-tooltip-id={`lesson-tooltip-${lesson.id}`} data-tooltip-content={lesson.name} data-tooltip-place="top" >
                                {lesson.name.length > 10 ? lesson.name.substring(0, 10) + "..." : lesson.name}
                              </span>
                              {lesson.name.length > 10 && <Tooltip id={`lesson-tooltip-${lesson.id}`} />}
                            </td>

                            <td className="text-center">{lesson.unit}</td>

                            <td className="text-center">
                              {lesson.grade.gradeId === "1" ? lesson.grade.gradeName.substring(0, 6) : lesson.grade.gradeName}
                            </td>



                            {/* Tribe with Tooltip */}
                            <td className="text-center">
                              <span
                                data-tooltip-id={`tribe-tooltip-${lesson.id}`}
                                data-tooltip-content={lesson.tribe}
                                data-tooltip-place="top"
                              >
                                {lesson.tribe.length > 10 ? lesson.tribe.substring(0, 10) + "..." : lesson.tribe}
                              </span>
                              {lesson.tribe.length > 10 && <Tooltip id={`tribe-tooltip-${lesson.id}`} />}
                            </td>

                            <td className="text-center">
                              <span className={lesson.status === "PUBLISHED" ? "activeStatus" : (lesson.status === "DRAFT" ? "draftStatus" : "inactiveStatus")}>
                                {lesson.status}
                              </span>
                            </td>

                            <td className="text-center">
                              <div className="dropdown dots">
                                <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                  <img src='./assets/images/more.svg' alt='action button' />
                                </button>
                                <ul className="dropdown-menu">
                                  {lesson.status !== "UNPUBLISHED" && <li>
                                    <button className="dropdown-item" onClick={() => handlePreview(lesson.id)}>
                                      <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                      Preview
                                    </button>
                                  </li>}
                                  <li>
                                    <button className="dropdown-item" onClick={() => handleEditBtn(lesson)}>
                                      <img src="assets/images/edit-icon.png" alt="" className="me-2" />
                                      Edit
                                    </button>
                                  </li>
                                  <li>
                                    <button className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDelete(lesson)}>
                                      <img src="assets/images/delete.png" alt="" className="me-2" />
                                      Delete
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  :
                  (!loading.tableLoading && <p className="text-center mt-5">No Data Found</p>)
              }
              {/* Pagination Controls */}
              <div className="pagination-container">

                <nav className='d-flex justify-content-between'>
                  <div className='page-length'>
                    Showing {Math.min(indexOfFirstItem + 1, lessonCount)} - {Math.min(indexOfLastItem, lessonCount)} of {lessonCount}
                  </div>
                  <ul className="pagination justify-content-center mx-auto">
                    <li className="page-item">
                      <button className="page-link" onClick={() => handlePagination(currentPage - 1, "left")} aria-label="Previous">
                        <span aria-hidden="true"><img src="assets/images/arrow-left-small.svg" alt="" /></span>
                      </button>
                    </li>
                    <li className="page-item disabled">
                      <span className="page-link">
                        {indexOfFirstItem + 1} of {indexOfLastItem}
                      </span>
                    </li>
                    <li className="page-item">
                      <button className="page-link" onClick={() => handlePagination(currentPage + 1, "right")} aria-label="Next" >
                        <span aria-hidden="true"><img src="assets/images/arrow-right-small.svg" alt="" /></span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            {loading.deleteLoading &&  // Show loader when loading is true
              <Loader message="Loading, Deleting Data..." />
            }
          </div>
          :
          <div>
            <h2 className="main-title text-center page-title">{(lessonData.id) ? lessonData.lessonName : "Add Lesson"}</h2>
            <Form noValidate onSubmit={handleSubmit}>
              <div className="pCard" style={{ backgroundColor: "#ffffff" }}>

                <div className="row">

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Tribe <span className="text-danger">*</span></h6>
                      <select className="form-select" name="lessonTribe" value={lessonData.lessonTribe?.id || ""} onChange={(e) => handleDropdown(e, e.target.value, e.target.options[e.target.selectedIndex].text)} onBlur={checkLessonName} required >
                        <option value="" disabled>
                          Select Tribe
                        </option>
                        {dropDownList.tribe.length > 0 ? (
                          dropDownList.tribe.map((option: any) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No Tribe added yet
                          </option>
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Subject <span className="text-danger">*</span></h6>
                      <select className="form-select" name="lessonSubject" value={lessonData.lessonSubject?.id || ""}
                        onChange={(e) => handleDropdown(e, e.target.value, e.target.options[e.target.selectedIndex].text)}
                        required >
                        <option value="" disabled>
                          Select Subject
                        </option>
                        {dropDownList.subject.length > 0 ? (
                          dropDownList.subject.map((option: any) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            {`${lessonData.lessonTribe.id ? `No Subject in ${lessonData.lessonTribe.name} Tribe` : `Select the valid tribe from tribe dropdown`}`}
                          </option>
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>
                        Grade <span className="text-danger">*</span>
                      </h6>
                      <select className="form-select" name="lessonGrade" value={lessonData.lessonGrade?.id || ""} onChange={(e) => handleDropdown(e, e.target.value, e.target.options[e.target.selectedIndex].text)} required >
                        <option value="" disabled>Select Grade</option>
                        {dropDownList.grade.length > 0 ? (
                          <React.Fragment>
                            {dropDownList.grade.map((option: any) => (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </React.Fragment>
                        ) : (
                          <option value="" disabled>No Grade added yet</option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Name <span className="text-danger">*</span></h6>
                      <input type="text" name="lessonName" value={lessonData.lessonName} className="form-control" placeholder="Lesson Name" onChange={handleInputChange} onBlur={checkLessonName} maxLength={50} required />
                      <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid name.</div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Description <span className="text-danger">*</span></h6>
                      <textarea rows={7} name="lessonDescription" placeholder="Lesson Description" value={lessonData.lessonDescription} onChange={handleInputChange} />

                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Banner <span className="text-danger">*</span></h6>
                      <div className="customImgUpload">
                        <div className="uploadBtn">
                          {lessonData.lessonMedia.DesktopBanner.files ?
                            <div className='w-100'>
                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                  <img src={lessonData.lessonMedia.DesktopBanner.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(lessonData.lessonMedia.DesktopBanner.files)} />
                                </div>
                              </div>

                            </div>
                            :
                            <>
                              <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />

                              <label htmlFor="customDesktopBannerFile">Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span></label>
                              <input type="file" className="form-control d-none" name="DesktopBanner" id="customDesktopBannerFile" accept=".png, .jpg, .jpeg" onChange={handleMediaFiles} required />
                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a desktop banner.</div>
                            </>}


                        </div>
                      </div>
                    </div>
                    {lessonData.lessonMedia.DesktopBanner.files && <div className="row justify-content-center">
                      <div className="col-auto">
                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("DesktopBanner", -1, lessonData.lessonMedia.DesktopBanner.blobPath, lessonData.lessonMedia.DesktopBanner.files)}>
                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                        </button>
                      </div>
                    </div>}
                  </div>

                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Badge <span className="text-danger">*</span></h6>
                      <div className="customImgUpload">
                        <div className="uploadBtn">
                          {lessonData.lessonMedia.BadgeIcon.files ?
                            <div className='w-100'>
                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                  <img src={lessonData.lessonMedia.BadgeIcon.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(lessonData.lessonMedia.BadgeIcon.files)} />
                                </div>
                              </div>

                            </div>
                            :
                            <>
                              <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                              <label htmlFor="customLessonBadgeIconFile">Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span></label>
                              <input type="file" className="form-control d-none" name="BadgeIcon" id="customLessonBadgeIconFile" accept=".png, .jpg, .jpeg" onChange={handleMediaFiles} required />
                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a lesson badge.</div>

                            </>}
                        </div>
                      </div>
                    </div>
                    {lessonData.lessonMedia.BadgeIcon.files && <div className="row justify-content-center">
                      <div className="col-auto">
                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("BadgeIcon", -1, lessonData.lessonMedia.BadgeIcon.blobPath, lessonData.lessonMedia.BadgeIcon.files)}>
                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                        </button>
                      </div>
                    </div>}
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Badge Description <span className="text-danger">*</span></h6>
                      <ReactQuill id="lessondescription" value={lessonData.badgeDescription || ""} style={{ backgroundColor: "#F0F2F6" }} onChange={(value) => handleBadgeDescriptionChange(value)}
                        modules={{
                          toolbar: [
                            [{ header: [3, 4, false] }],
                            ["bold", "italic", "underline", "blockquote"],
                            [
                              { list: "ordered" },
                              { list: "bullet" },
                              { indent: "-1" },
                              { indent: "+1" },
                            ],
                            [{ align: [] }],
                          ],
                        }}
                      />

                    </div>
                  </div>
                </div>





                <div className="row">

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Video Thumbnail <span className="text-danger">*</span></h6>
                      <div className="customImgUpload">
                        <div className="uploadBtn">
                          {lessonData.lessonMedia.Thumbnail.files ?
                            <div className='w-100'>
                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                  <img src={lessonData.lessonMedia.Thumbnail.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(lessonData.lessonMedia.Thumbnail.files)} />
                                </div>
                              </div>

                            </div>
                            :
                            <>
                              <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                              <label htmlFor="customLessonthumbnailFile">Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span></label>
                              <input type="file" className="form-control d-none" name="Thumbnail" id="customLessonthumbnailFile" accept=".png, .jpg, .jpeg" onChange={handleMediaFiles} required />
                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a thumbnail.</div>

                            </>}
                        </div>
                      </div>
                    </div>
                    {lessonData.lessonMedia.Thumbnail.files && <div className="row justify-content-center">
                      <div className="col-auto">
                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("Thumbnail", -1, lessonData.lessonMedia.Thumbnail.blobPath, lessonData.lessonMedia.Thumbnail.files)}>
                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                        </button>
                      </div>
                    </div>}
                  </div>


                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Video Intro Text <span className="text-danger">*</span></h6>
                      <ReactQuill id="lessondescription" value={lessonData.lessonIntroText || ""} style={{ backgroundColor: "#F0F2F6" }} onChange={(value) => handleLessonDesriptionChange(value)}
                        modules={{
                          toolbar: [
                            [{ header: [3, 4, false] }],
                            ["bold", "italic", "underline", "blockquote"],
                            [
                              { list: "ordered" },
                              { list: "bullet" },
                              { indent: "-1" },
                              { indent: "+1" },
                            ],
                            [{ align: [] }],
                          ],
                        }}
                      />

                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Video <span className="text-danger">*</span></h6>
                      <div className="customImgUpload">
                        <div className="uploadBtn">
                          {lessonData.lessonMedia.IntroVideo.files ?
                            <div className='w-100'>
                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                  <video controls style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", margin: "0 auto" }}>
                                    <source src={lessonData.lessonMedia.IntroVideo.blobPath} type="video/mp4" />
                                    Your browser does not support the video tag.
                                  </video>

                                </div>
                              </div>
                            </div>
                            :
                            <>
                              <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                              <label htmlFor="customIntroVideoFile">Click to upload<span>mp4 or webm <br />(max 250mb)</span></label>
                              <input type="file" className="form-control d-none" name="IntroVideo" id="customIntroVideoFile" accept=".mp4, .WebM" onChange={handleMediaFiles} required />
                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a video.</div>
                            </>}
                        </div>
                      </div>
                    </div>
                    {lessonData.lessonMedia.IntroVideo.files && <div className="row justify-content-center">
                      <div className="col-auto">
                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("IntroVideo", -1, lessonData.lessonMedia.IntroVideo.blobPath, lessonData.lessonMedia.IntroVideo.files)}>
                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                        </button>
                      </div>
                    </div>}
                  </div>


                </div>





                <div className="form-group">
                  <div style={{ paddingLeft: "3%" }}>
                    <h6 className='highlightMediaText'>Lesson Unit <span className="text-danger">*</span></h6>
                    {lessonData.id ? (
                      lessonData.lessonUnits.length > 0 ? (
                        <div>
                          <div className="accordion formAcc mb-3" id="accordionExample">
                            {lessonData.lessonUnits.map((unit, index) => (
                              <div key={index} className='form-group'>
                                <div className="accordion-item p-2" style={{ backgroundColor: "#F0F2F6", borderRadius: "18px" }}>
                                  <div className="row">

                                    <div className="col-md-10">
                                      <h2 className="accordion-header" id={`heading${index}`}>
                                        <button className="form-control accordion-button collapsed border-0 bg-transparent" type="button" data-bs-toggle="collapse" style={{ backgroundColor: "#F0F2F6", borderRadius: "15px", border: "0px" }} data-bs-target={`#collapse${index}`} aria-expanded={index === 0 ? "true" : "false"} aria-controls={`collapse${index}`} >
                                          {unit.name}
                                        </button>
                                      </h2>
                                    </div>
                                    <div className="col-auto" style={{ border: "none" }}>
                                      <div className="d-flex justify-content-between h-100">
                                        {lessonData.lessonUnits.length - 1 === index && lessonData.lessonNewUnits.length < 1 &&
                                          <button className="btn" type="button" id="button-addon2" onClick={handleAddUnit}>
                                            <img src="./assets/images/add-icon.svg" alt="Add" />
                                          </button>
                                        }
                                        <button className="btn border-bottom rounded-0 dltbtn" name={unit.id} type="button" id="button-addon2" onClick={() => handleDeleteUnit(unit, index)}>
                                          <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>


                                  <div id={`collapse${index}`} className={`accordion-collapse collapse`} aria-labelledby={`heading${index}`} data-bs-parent="#accordionExample" >
                                    <div style={{ padding: "20px 0px" }}>

                                      <div className="row">
                                        <div className="col-md-10">
                                          <div className="form-group">
                                            <h6 className='highlightMediaText'>{`Unit ${index + 1} Banner`} <span className="text-danger">*</span></h6>
                                            <div className="customImgUpload" style={{ backgroundColor: "#D9DDEA", borderRadius: "15px" }}>
                                              <div className="uploadBtn">
                                                {unit.unitMedia.desktop.files ? (
                                                  <div className='w-100'>
                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                        <img src={unit.unitMedia.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(unit.unitMedia.desktop.files)} />

                                                      </div>
                                                    </div>

                                                  </div>
                                                ) : (
                                                  <>
                                                    <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                                                    <label htmlFor={`CustomAddedUnitDesktopBanner${index}File`}>
                                                      Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                                    </label>
                                                    <input type="file" className="form-control d-none" id={`CustomAddedUnitDesktopBanner${index}File`} name="desktop" accept=".png, .jpg, .jpeg" onChange={(event) => handleUnitMedia(event, index, "addedUnit")} required />
                                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a unit banner.</div>
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          {unit.unitMedia.desktop.files && <div className="row justify-content-center">
                                            <div className="col-auto">
                                              <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("desktop", index, unit.unitMedia.desktop.blobPath, unit.unitMedia.desktop.files)}>
                                                <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                              </button>
                                            </div>
                                          </div>}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-10">
                                        <div className="form-group">
                                          <h6 className='highlightMediaText'>{`Unit ${index + 1} Level`}</h6>
                                          <select name="unitLevel " style={{ backgroundColor: "#D9DDEA", borderRadius: "15px" }} className="form-select" value={unit?.level ?? ""} onChange={(event) => handleUnitInputChanges(event, index)} required >
                                            <option value="" disabled>
                                              {`Select Unit ${index + 1} Level`}
                                            </option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                          </select>
                                          <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a valid unit level.</div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>

                                </div>
                              </div>
                            ))}
                          </div>

                          {lessonData.lessonNewUnits.map((newUnit, index) => (
                            <div key={index + lessonData.lessonUnits.length} className='p-2' style={{
                              backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#F0F2F6" : "#FFFFFF",
                              borderRadius: "15px"
                            }}>
                              <div className="row">
                                <div className="col-md-10">
                                  <div className="form-group">
                                    <input type="text" className="form-control " placeholder={`New Unit ${index + lessonData.lessonUnits.length + 1} Name`} name="newUnitName" value={newUnit.name || ""} onChange={(event) => handleUnitInputChanges(event, index)} onBlur={checkUnitName} maxLength={30} required />
                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid unit name.</div>
                                  </div>
                                </div>
                                <div className="col-md-2 mt-1">
                                  {index === lessonData.lessonNewUnits.length - 1 && (
                                    <button className="btn" type="button" id="button-addon2" onClick={handleAddUnit}>
                                      <img src="./assets/images/add-icon.svg" alt="Add" />
                                    </button>
                                  )}

                                  {index !== lessonData.lessonNewUnits.length - 1 && (
                                    <button className="btn" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseUnit${index}`} aria-expanded="false" aria-controls={`collapseUnit${index}`}>
                                      <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                    </button>
                                  )}
                                  <button className="btn" type="button" id="button-addon2" onClick={() => handleDeleteUnit(newUnit, index, "newUnit")}>
                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                  </button>
                                </div>
                              </div>
                              <div className={`accordion-body ${(lessonData.lessonNewUnits.length - 1) === index ? "show" : "collapse"}`} id={`collapseUnit${index}`}>

                                <div className="row">
                                  <div className="col-md-10">

                                    <div className="form-group">
                                      <h6 className='highlightMediaText'>{`Unit ${index + lessonData.lessonUnits.length + 1} Banner`} <span className="text-danger">*</span></h6>
                                      <div className="customImgUpload" style={{ backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                        <div className="uploadBtn">
                                          {newUnit.unitMedia.desktop.files ? (
                                            <div className='w-100'>
                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                  <img src={`${newUnit.unitMedia.desktop.blobPath}`} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newUnit.unitMedia.desktop.files)} />

                                                </div>
                                              </div>

                                            </div>
                                          ) : (
                                            <>
                                              <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                                              <label htmlFor={`CustomDesktopBanner${index}File`}>
                                                Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                              </label>
                                              <input type="file" className="form-control d-none" id={`CustomDesktopBanner${index}File`} name="desktop" accept=".png, .jpg, .jpeg" onChange={(event) => handleUnitMedia(event, index, "newUnit")} required />
                                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a unit banner.</div>

                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    {newUnit.unitMedia.desktop.files && <div className="row justify-content-center">
                                      <div className="col-auto">
                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("desktop", index, newUnit.unitMedia.desktop.blobPath, newUnit.unitMedia.desktop.files)}>
                                          <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                        </button>
                                      </div>
                                    </div>}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-10">
                                    <h6 className='highlightMediaText'>{`Unit ${index + lessonData.lessonUnits.length + 1} Level`} <span className="text-danger">*</span></h6>
                                    <div className="form-group">
                                      <select name="newUnitLevel" className="form-select" style={{ backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} value={newUnit?.level ?? ""} onChange={(event) => handleUnitInputChanges(event, index)} required >
                                        <option value="" disabled>
                                          {`Select Unit ${index + lessonData.lessonUnits.length + 1} Level`}
                                        </option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                      </select>
                                      <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a valid unit level.</div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          ))}

                        </div>
                      ) : (

                        (lessonData.lessonNewUnits.map((newUnit, index) => (
                          <div key={index + lessonData.lessonUnits.length} className='p-2' style={{
                            backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#F0F2F6" : "#FFFFFF",
                            borderRadius: "15px"
                          }}>
                            <div className="row">
                              <div className="col-md-10">
                                <div className="form-group">
                                  <input type="text" className="form-control " placeholder={`New Unit ${index + lessonData.lessonUnits.length + 1} Name`} name="newUnitName" value={newUnit.name || ""} onChange={(event) => handleUnitInputChanges(event, index)} onBlur={checkUnitName} maxLength={30} required />
                                  <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid unit name.</div>
                                </div>
                              </div>
                              <div className="col-md-2 mt-1">
                                {index === lessonData.lessonNewUnits.length - 1 && (
                                  <button className="btn" type="button" id="button-addon2" onClick={handleAddUnit}>
                                    <img src="./assets/images/add-icon.svg" alt="Add" />
                                  </button>
                                )}

                                {index !== lessonData.lessonNewUnits.length - 1 && (
                                  <button className="btn" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseUnit${index}`} aria-expanded="false" aria-controls={`collapseUnit${index}`}>
                                    <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                  </button>
                                )}
                                <button className="btn" type="button" id="button-addon2" onClick={() => handleDeleteUnit(newUnit, index, "newUnit")}>
                                  <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                </button>
                              </div>
                            </div>
                            <div className={`accordion-body ${(lessonData.lessonNewUnits.length - 1) === index ? "show" : "collapse"}`} id={`collapseUnit${index}`}>

                              <div className="row">
                                <div className="col-md-10">

                                  <div className="form-group">
                                    <h6 className='highlightMediaText'>{`Unit ${index + lessonData.lessonUnits.length + 1} Banner`} <span className="text-danger">*</span></h6>
                                    <div className="customImgUpload" style={{ backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                      <div className="uploadBtn">
                                        {newUnit.unitMedia.desktop.files ? (
                                          <div className='w-100'>
                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                              <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                <img src={`${newUnit.unitMedia.desktop.blobPath}`} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(newUnit.unitMedia.desktop.files)} />

                                              </div>
                                            </div>

                                          </div>
                                        ) : (
                                          <>
                                            <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                                            <label htmlFor={`CustomDesktopBanner${index}File`}>
                                              Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                            </label>
                                            <input type="file" className="form-control d-none" id={`CustomDesktopBanner${index}File`} name="desktop" accept=".png, .jpg, .jpeg" onChange={(event) => handleUnitMedia(event, index, "newUnit")} required />
                                            <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a unit banner.</div>

                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {newUnit.unitMedia.desktop.files && <div className="row justify-content-center">
                                    <div className="col-auto">
                                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("desktop", index, newUnit.unitMedia.desktop.blobPath, newUnit.unitMedia.desktop.files)}>
                                        <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                      </button>
                                    </div>
                                  </div>}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-10">
                                  <h6 className='highlightMediaText'>{`Unit ${index + lessonData.lessonUnits.length + 1} Level`} <span className="text-danger">*</span></h6>
                                  <div className="form-group">
                                    <select name="newUnitLevel" className="form-select" style={{ backgroundColor: lessonData.lessonNewUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} value={newUnit?.level ?? ""} onChange={(event) => handleUnitInputChanges(event, index)} required >
                                      <option value="" disabled>
                                        {`Select Unit ${index + lessonData.lessonUnits.length + 1} Level`}
                                      </option>
                                      <option value="1">1</option>
                                      <option value="2">2</option>
                                      <option value="3">3</option>
                                    </select>
                                    <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a valid unit level.</div>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </div>
                        )))

                      )
                    ) :
                      lessonData.lessonUnits.map((unit, index) => (
                        <div key={index} className='p-2' style={{
                          backgroundColor: lessonData.lessonUnits.length - 1 !== index ? "#F0F2F6" : "#FFFFFF",
                          borderRadius: "15px"
                        }}>
                          <div className="row mb-3 form-group" style={{ marginBottom: "0" }}>
                            <div className="col-md-10">
                              <input type="text" className="form-control" placeholder={`Unit ${index + 1} Name`} name="unitName" value={unit.name || ""} onChange={(event) => handleUnitInputChanges(event, index)} onBlur={checkUnitName} maxLength={50} required />
                              <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid unit name.</div>

                            </div>
                            <div className="col-auto">
                              <div className="d-flex justify-content-between h-100">
                                {index === lessonData.lessonUnits.length - 1 && (
                                  <button className="btn p-0" type="button" id="button-addon2" onClick={handleAddUnit} >
                                    <img src="./assets/images/add-icon.svg" alt="Add" />
                                  </button>
                                )}

                                {index !== lessonData.lessonUnits.length - 1 && (
                                  <button className="btn p-0" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseUnit${index}`} aria-expanded="false" aria-controls={`collapseUnit${index}`}>
                                    <img width="24" src="./assets/images/down-arrow.png" alt="" />
                                  </button>
                                )}
                                {lessonData.lessonUnits.length > 1 && (
                                  <button className="btn" type="button" id="button-addon2" onClick={(event) => handleDeleteUnit(unit, index, "oldUnit")} >
                                    <img src="./assets/images/delete.svg" alt="Delete" width="24" />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>


                          <div className={`accordion-body ${(lessonData.lessonUnits.length - 1) === index ? "show" : "collapse"}`} id={`collapseUnit${index}`}>



                            <div className="row">
                              <div className="col-md-10">
                                <h6 className='highlightMediaText'>{`Unit ${index + 1} Banner`} <span className="text-danger">*</span></h6>
                                <div className="form-group">
                                  <div className="customImgUpload" style={{ backgroundColor: lessonData.lessonUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }}>
                                    <div className="uploadBtn">
                                      {unit.unitMedia.desktop.files ?
                                        <div className="w-100">
                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                              <img src={unit.unitMedia.desktop.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(unit.unitMedia.desktop.files)} />

                                            </div>
                                          </div>
                                        </div>
                                        :
                                        <>
                                          <img className="noimage" src="./assets/images/no-image-icon.png" alt="" />
                                          <label htmlFor={`CustomDesktopBanner${index}File`}>
                                            Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                          </label>
                                          <input type="file" className="form-control d-none" id={`CustomDesktopBanner${index}File`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(event) => handleUnitMedia(event, index, "newUnit")} required />
                                          <div className="invalid-feedback" style={{ textAlign: "center" }}>Please upload a unit banner.</div>
                                        </>}
                                    </div>
                                  </div>
                                </div>
                                {unit.unitMedia.desktop.files && <div className="row justify-content-center">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleS3PathDelete("desktop", index, unit.unitMedia.desktop.blobPath, unit.unitMedia.desktop.files)} >
                                      <img src="./assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                    </button>
                                  </div>
                                </div>}
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-10">
                                <div className="form-group">
                                  <h6 className='highlightMediaText'>{`Unit ${index + 1} Level`} <span className="text-danger">*</span></h6>
                                  <select name="unitLevel" className="form-select" value={unit?.level ?? ""} style={{ backgroundColor: lessonData.lessonUnits.length - 1 !== index ? "#D9DDEA" : "#F0F2F6", borderRadius: "15px" }} onChange={(event) => handleUnitInputChanges(event, index)} required  >
                                    <option value="" disabled>
                                      Select Unit {index + 1} Level
                                    </option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                  </select>
                                  <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a valid unit level.</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>



                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <h6 className='highlightMediaText'>Lesson Status <span className="text-danger">*</span></h6>
                      <select className="form-select" name="lessonStatus" value={lessonData?.lessonStatus ?? ""} onChange={(event) => handleDropdown(event, "-1", "lessonStatus")} required >
                        <option value="" disabled>
                          Select Lesson Status
                        </option>
                        <option value="2">Draft</option>
                        <option value="1">Publish</option>
                        <option value="0">Unpublish</option>
                      </select>
                      <div className="invalid-feedback" style={{ textAlign: "center" }}>Please select a status.</div>
                    </div>
                  </div>
                </div>

                <div className="form-actions">
                  <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-3"></div>

                    <div className="col-md-3">
                      <div className="btn-group w-100">
                        <button type="button" className="btn btn-save btnPurple" onClick={handleSubmit} >Save</button>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                    </div>
                  </div>
                </div>

              </div>
            </Form>
            {loading.deleteLoading &&  // Show loader when loading is true
              <Loader message="Loading, Deleting Data..." />
            }
            {loading.fetchingLoading &&  // Show loader when loading is true
              <Loader message="Loading, Fetching Data..." />
            }
            {loading.submitLoading &&  // Show loader when loading is true
              <Loader message="Loading, Submitting Data..." />
            }

          </div>
        }
      </div>

      {show &&
        <ConfirmationPopup
          title={confirmationPopupData.title}
          message={confirmationPopupData.message}
          isBackIterated={true}
          descriptions={confirmationPopupData.descriptions}
          acceptText={confirmationPopupData.acceptText}
          cancelText={confirmationPopupData.cancelText}
          onAccept={confirmationPopupData.onAccept}
          onCancel={confirmationPopupData.onCancel}
          onCrossClick={() => setShow(false)}
        />
      }
      {message.errorMessage.length > 0 &&
        <CustomAlert
          errorCount={message.errorMessage.length}
          messages={message.errorMessage}
          onClose={() => { setMessage({ ...message, errorMessage: [] }); }}
        />
      }
      <FullScreenImagePreview
        show={showPreview.imageShow}
        imagePath={previewSource}
        onClose={handleClosePreview}
      />
    </div>
  );
}

export default Lesson